import { InjectedConnector } from '@web3-react/injected-connector';

export const injectedConnector = new InjectedConnector({
    supportedChainIds: [
      4, // Rinkeby
      100,// XDAI Mainnet
      55555,// REI Testnet
    ],
  });
